import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from 'react-tooltip';
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar, Grid } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/scrollbar";
import { getAllProductCategory } from "../../../actions/ProductCategoryActions";
import { getAllProduct, getProductByCategoryId } from "../../../actions/ProductActions";
import AddProduct from "../addProductModal";
import Select from 'react-select'
import { styleSelect } from "../../../constants/customStyles";
import { ThreeDots } from "react-loader-spinner";
import Toast from "../../../components/Toast";

const Step3 = (props) => {

    const dispatch = useDispatch();

    const { data, handleChange, next, back, productCategories, products, onClickAdd, getProducts, activeDiv, setActiveDiv, allItems, setAllItems, selectedItem, setSelectedItem, subTotal, setSubTotal, discount, setDiscount, netTotal, setNetTotal, saveButton } = props;
    const [quantity, setQuantity] = useState(1);
    const [note, setNote] = useState(0);
    const loading = useSelector(state => state?.loading?.loading);

    useEffect(() => {
        if (data && data.length > 0) {
            setAllItems(allItems => data);
        }
    }, [data])

    const calSubTotal = () => {
        let subTotalA = 0;
        allItems.forEach(item => {
            subTotalA += parseInt(item.sale_price);
        });
        setSubTotal(subTotalA);
    }

    const calDiscount = () => {
        let total = subTotal;
        // 'total', total)
        if (discount != 0) {
            let discountAmount = parseInt(total) * (parseInt(discount) / 100);
            setNetTotal(total - discountAmount)
        } else {
            setNetTotal(total)
        }
    }

    const onClickItem = (selectedItem) => {
        const updatedItems = [...allItems];

        selectedItem.product_name = selectedItem.name;
        selectedItem.product_type = selectedItem.product_type;
        selectedItem.product_id = selectedItem.product_id;
        selectedItem.sale_price = selectedItem.sale_price;

        const foundIndex = updatedItems.findIndex(item => item.product_id === selectedItem.product_id);
        const foundIndexOldItems = updatedItems.findIndex(item => item.product_id === parseInt(selectedItem.product_id));

        if (foundIndex !== -1) {
            Toast.fire({
                icon: 'error',
                title: 'Item Already Exists!'
            });
            setSelectedCategory('');
            setProductCategory('');
            setProduct('');
            setSelectedProduct('');
        } else {
            selectedItem.quantity = 1;
            updatedItems.unshift(selectedItem);
        }
        setAllItems(updatedItems);

    }
    // const onClickItem = (selectedItem) => {
    //     'selectedItem', selectedItem)
    //     selectedItem.quantity = 1;
    //     selectedItem.product_name = selectedItem.name;
    //     let found = false;
    //     let foundIndex = null;
    //     if (selectedItem) {
    //         if (allItems.length > 0) {
    //             let items = allItems;
    //             // 
    //             items.map((item, index) => {
    //                 // 'selectedItem', selectedItem);
    //                 // 'item', item);
    //                 if (item.product_id == selectedItem.id) {
    //                     found = true;
    //                     foundIndex = index;
    //                     // selectedItem.quantity = item.quantity;
    //                     item.quantity += 1;
    //                     // setAllItems(allItems.slice(index))
    //                 } else {
    //                     return item;
    //                 }
    //             })
    //             // foundIndex)
    //             // if(foundIndex){
    //             //     'foundIndex', foundIndex)
    //             //     setAllItems(allItems.slice(foundIndex));
    //             //     // foundIndex = null;
    //             // }
    //             if (!found) {
    //                 setAllItems(allItems => [selectedItem, ...allItems]);
    //             } else {
    //                 // setAllItems(
    //                 //     allItems.map((item) => {
    //                 //         return item.id === selectedItem.id? selectedItem: item;
    //                 //     })
    //                 // ); 

    //                 // ---------------------
    //                 // 'allItems', allItems)
    //                 let item = allItems;
    //                 'item[foundIndex].quantity', item[foundIndex].quantity)
    //                 item[foundIndex].quantity = item[foundIndex].quantity + 1;
    //                 'item', item)
    //                 setAllItems([...item]);
    //             }
    //             // 'items', items)
    //         } else {
    //             setAllItems(allItems => [selectedItem, ...allItems]);
    //         }
    //         // items)
    //     }
    // }


    // useEffect(() => {
    //     'selectedItem', selectedItem)
    //     if (selectedItem) {
    //         if(allItems.length > 0){
    //             let items = allItems;
    //             
    //             items.map(item => {
    //                 'selectedItem', selectedItem);
    //                 'item', item);
    //                 if(item.product_id == selectedItem.product_id){
    //                     item.quantity += 1;
    //                     // return item;
    //                 }
    //                 return item;
    //             })
    //             setAllItems(allItems => [selectedItem, ...allItems]);
    //             // 'items', items)
    //         } else {
    //             setAllItems(allItems => [selectedItem, ...allItems]);
    //         }
    //         // items)
    //     }
    // }, [selectedItem])

    useEffect(() => {
        if (allItems.length > 0) {
            calSubTotal();
            // calDiscount();
        }
    }, [allItems])

    useEffect(() => {
        if (subTotal != 0) {
            calDiscount();
        }
    }, [subTotal])

    useEffect(() => {
        if (discount != 0) {
            calDiscount();
        } else {
            setNetTotal(subTotal)
        }
    }, [discount])

    const deleteItem = (e, item, index) => {
        // 'item', item);
        let items = allItems;
        items.splice(items.indexOf(item), 1);
        // items.slice(0, index);
        // 
        if (items.length > 0) {
            setAllItems([...items]);
        } else {
            setAllItems([]);
        }
    }

    const [searchTerm, setSearchTerm] = useState('');

    const filteredProducts = products && Object.keys(products).length > 0 && products.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const [productCategory, setProductCategory] = useState('');
    const [product, setProduct] = useState('');
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedProduct, setSelectedProduct] = useState();
    const [cardView, setCardView] = useState(false);

    const handleChangeProductCategory = (e) => {
        getProducts(e.id)
        setProductCategory(e.id)
        setSelectedCategory({
            id: e.id,
            name: e.name
        });
    }
    const handleChangeProduct = (e) => {
        setProduct(e)
        setSelectedProduct({
            id: e.id,
            name: e.name
        });
    }

    const minusQuantity = (index) => {
        const updatedItems = [...allItems];
        if (updatedItems[index].quantity > 1) {
            updatedItems[index].quantity -= 1;
            setAllItems(updatedItems);
        }
    };

    const addQuantity = (index) => {
        const updatedItems = [...allItems];
        updatedItems[index].quantity += 1;
        setAllItems(updatedItems);
    };

    return (
        <React.Fragment>
            <div className="d-flex align-items-center mt-8">
                <h2 className="intro-y fs-lg fw-medium me-auto">
                    Investigation
                </h2>
            </div>
            <div className="intro-y box py-10 py-10 px-5 mt-5">
                <div className="wizard d-flex flex-column flex-lg-row justify-content-center">
                    <div className="intro-x text-lg-center d-flex align-items-center d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">1</button>
                        <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Customer Details</div>
                    </div>
                    <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">2</button>
                        <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Vehicle Details</div>
                    </div>
                    <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">3</button>
                        <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Products Added</div>
                    </div>
                    <div className="wizard__line d-none d-lg-block w-2/3 bg-gray-200 dark-bg-dark-1 position-absolute mt-5"></div>
                </div>
                <div className="px-5 mt-10 pt-5 border-top border-gray-200 dark-border-dark-5">
                    <div className="intro-y d-flex flex-column flex-sm-row align-items-center">
                        <h2 className="fs-lg fw-medium me-auto">
                            Products:
                            <button className="btn btn-primary p-1 ms-1" data-bs-toggle="modal" data-bs-target="#add-product-modal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-plus w-4 h-4"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                            </button>
                        </h2>
                        <div class="intro-y pe-1">
                            <div class="box p-2">
                                <ul class="chat__tabs nav nav-pills rounded-2" role="tablist">
                                    <li id="chats-tab" class="nav-item flex-1" role="presentation">
                                        <button onClick={() => setCardView(false)} class="nav-link w-full pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#chats" type="button" role="tab" aria-controls="chats-tab" aria-selected="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg></button>
                                    </li>
                                    <li id="friends-tab" onClick={() => setCardView(true)} class="nav-item flex-1" role="presentation">
                                        <button class="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#friends" type="button" role="tab" aria-controls="friends-tab" aria-selected="false"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content mt-3">
                        <div class="tab-pane fade show active" id="chats" role="tabpanel" aria-labelledby="chats-tab">
                            <div className="pos intro-y grid columns-12 gap-5">
                                <div className="intro-y g-col-12 g-col-lg-12">
                                    <div className="grid columns-12 align-items-center">
                                        <div className="g-col-12 g-col-sm-12 border border-gray-300 rounded-2 me-3 p-3">
                                            <div className="position-relative text-gray-700 dark-text-gray-300">
                                                <input
                                                    type="text"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    className="form-control py-3 px-4 box border-white dark-border-dark-3 w-full placeholder-theme-13"
                                                    placeholder="Search item..."
                                                />
                                                <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        searchTerm &&
                                        <div className="grid columns-12 border border-gray-300 rounded-2 mt-3 p-3">
                                            <div className="g-col-12 g-col-lg-6 g-col-md-12 g-col-sm-12">
                                                <label for="crud-form-1" className="form-label fw-medium">Spare Parts :</label>
                                                <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                                                    {
                                                        searchTerm && filteredProducts &&
                                                        filteredProducts.map((product) => (
                                                            product?.product_type === 'goods' ? (
                                                                <div className="m-2 float-start p-1" key={product.product_id}>
                                                                    <button className="btn btn-secondary-outline w-fit-content border border-gray-500" type="button" onClick={() => onClickItem(product)}>
                                                                        {product?.name}
                                                                    </button>
                                                                </div>
                                                            ) : null
                                                        ))
                                                    }

                                                </div>
                                            </div>
                                            <div className="g-col-12 g-col-lg-6 g-col-md-12 g-col-sm-12">
                                                <label for="crud-form-1" className="form-label fw-medium">Repairs :</label>
                                                <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                                                    {
                                                        searchTerm && filteredProducts &&
                                                        filteredProducts.map((product) => (
                                                            product?.product_type === 'service' ? (
                                                                <div className="m-2 float-start p-1" key={product.product_id}>
                                                                    <button className="btn btn-secondary-outline w-fit-content border border-gray-500" type="button" onClick={() => onClickItem(product)}>
                                                                        {product?.name}
                                                                    </button>
                                                                </div>
                                                            ) : null
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        allItems && allItems.length > 0 && Object.keys(allItems).length > 0 &&
                                        <table class="table table-striped border-top mt-5 border-gray-600">
                                            <thead>
                                                <tr>
                                                </tr>
                                                <tr>
                                                    <th className="text-nowrap">S. No</th>
                                                    <th className="text-nowrap">Parts / Services</th>
                                                    <th className="text-nowrap">Type</th>
                                                    <th className="text-nowrap ps-10">Quantity</th>
                                                    <th className="text-nowrap">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    allItems && Object.keys(allItems).length > 0 &&
                                                    allItems.map((detail, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{detail?.product_name}</td>
                                                                <td className="text-capitalize">{detail?.product_type === 'spare_parts' ? 'Spare Parts' : detail?.product_type}</td>
                                                                {/* <td>{detail?.sale_price}</td> */}
                                                                <td>
                                                                    <div class="input-group w-24 ">
                                                                        <div class="input-group-text cursor-pointer fw-medium" onClick={() => minusQuantity(index)}>-</div>
                                                                        <input type="text" class="form-control text-center p-1" value={detail?.quantity} placeholder="Quantity" />
                                                                        <div onClick={() => addQuantity(index)} class="input-group-text cursor-pointer fw-medium">+</div>
                                                                    </div>
                                                                </td>
                                                                {/* <td>{Number(parseInt(detail?.total_amount)).toFixed(1)}</td> */}
                                                                <td className="">
                                                                    {/* <a className="d-flex align-items-center me-5" href=""> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </a> */}
                                                                    <button className="d-flex align-items-center bg-transparent text-theme-6" onClick={(e) => deleteItem(e, detail, index)}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 me-1 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> Delete </button>
                                                                    {/* <a className="d-flex align-items-center text-theme-6" href="javascript:;" data-bs-toggle="modal" data-bs-target="#delete-confirmation-modal"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 me-1 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> Delete </a> */}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="friends" role="tabpanel" aria-labelledby="friends-tab">
                            <div className="d-flex justify-content-end mt-3">
                                <div className="position-relative text-gray-700 dark-text-gray-300">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="form-control py-3 px-4 w-full w-lg-64 box border-white dark-border-dark-3 pe-10 placeholder-theme-13"
                                        placeholder="Search item..."
                                    />
                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                </div>
                            </div>
                            <div className="pos intro-y grid columns-12 gap-5 mt-3">
                                <div className="intro-y g-col-12 g-col-lg-12">
                                    <span>

                                        <div className="gap-5 mt-2">
                                            <Swiper
                                                slidesPerView={4}
                                                scrollbar={{
                                                    hide: true,
                                                }}
                                                grid={{
                                                    rows: 1,
                                                }}
                                                modules={[Grid, Scrollbar]}
                                                className="mySwiper"
                                            >
                                                {
                                                    productCategories && productCategories.length > 0 &&
                                                    productCategories.map(productCategory => {
                                                        return (
                                                            <SwiperSlide>
                                                                <div onClick={() => getProducts(productCategory.id)} className={`${activeDiv == productCategory.id ? 'bg-primary box p-5 h-32 d-flex flex-column justify-content-center cursor-pointer zoom-in my-5 mx-3' : 'my-5 mx-3 h-32 d-flex flex-column justify-content-center box p-5 cursor-pointer zoom-in'}`}>
                                                                    <div id="active-text" className={`${activeDiv == productCategory.id ? 'fw-medium fs-base text-white' : 'fw-medium fs-base'}`}>{productCategory.name}</div>
                                                                    <div id="active-qty" className={`${activeDiv == productCategory.id ? 'text-gray-400' : 'text-gray-600'}`}>{productCategory.product_count} Items</div>
                                                                </div>
                                                            </SwiperSlide>
                                                        )
                                                    })
                                                }
                                            </Swiper>
                                        </div>
                                        <div className="mt-5 pt-5 border-top border-theme-5 dark-border-dark-3">
                                            {
                                                loading ?
                                                    <ThreeDots
                                                        height="80"
                                                        width="80"
                                                        radius="9"
                                                        color="#2d3748"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                                        wrapperClassName=""
                                                        visible={loading}
                                                    /> :
                                                    <span>
                                                        <Swiper
                                                            slidesPerView={5}
                                                            scrollbar={{
                                                                hide: true,
                                                            }}
                                                            grid={{
                                                                rows: 1,
                                                            }}
                                                            modules={[Grid, Scrollbar]}
                                                            className="mySwiper"
                                                        >
                                                            {filteredProducts && filteredProducts.map((product) => (
                                                                <SwiperSlide key={product.product_id}>
                                                                    <div
                                                                        onClick={() => onClickItem(product)}
                                                                        className="intro-y d-block box rounded-2 p-3 my-5 mx-3 position-relative zoom-in"
                                                                    >
                                                                        <div className="flex-none pos-image position-relative d-block">
                                                                            <div className="pos-image__preview image-fit">
                                                                                <img alt="Product Image" src="/images/product.jpeg" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-block fw-medium text-center truncate mt-3">{product?.name}</div>
                                                                    </div>
                                                                </SwiperSlide>
                                                            ))}
                                                        </Swiper>
                                                    </span>
                                            }
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="intro-y g-col-12 d-flex align-items-center justify-content-end mt-5 px-5">
                    <button className="btn btn-secondary w-24" onClick={back}>Previous</button>
                    <button className="btn btn-primary w-24 ms-2" disabled={loading ? true : false} type="button" onClick={saveButton}>Submit</button>
                </div>
            </div >
            <AddProduct />
            <div id="add-item-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">
                                Add Item
                            </h2>
                        </div>
                        <div className="modal-body grid grid-cols-12 gap-4 gap-y-3">
                            <div className="g-col-12">
                                <label for="pos-form-4" className="form-label">Quantity</label>
                                <div className="d-flex mt-2 flex-1">
                                    <button type="button" onClick={() => setQuantity(parseInt(quantity) - 1)} className="btn w-12 border-gray-300 bg-gray-200 dark-bg-dark-1 dark-border-dark-1 text-gray-600 dark-text-gray-300 me-1">-</button>
                                    <input id="pos-form-4" type="text" className="form-control w-24 text-center" placeholder="Item quantity" onChange={(e) => setQuantity(e.target.value)} value={quantity} />
                                    <button type="button" onClick={() => setQuantity(parseInt(quantity) + 1)} className="btn w-12 border-gray-300 bg-gray-200 dark-bg-dark-1 dark-border-dark-1 text-gray-600 dark-text-gray-300 ms-1">+</button>
                                </div>
                            </div>
                            <div className="g-col-12">
                                <label for="pos-form-5" className="form-label">Notes</label>
                                <textarea id="pos-form-5" onChange={handleChange} className="form-control w-full mt-2" placeholder="Item notes"></textarea>
                            </div>
                        </div>
                        <div className="modal-footer text-end">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-24 me-1">Back</button>
                            <button type="button" onClick={onClickAdd} className="btn btn-primary w-24">Add Item</button>
                        </div>
                    </div>
                </div>
            </div>
            {
                cardView == true && allItems &&
                    allItems.length > 0 ?
                    <div className="cursor-pointer position-fixed bottom-0 end-0 d-flex align-items-center justify-content-end w-full z-50 mb-1">
                        <a className="ms-auto me-11 bg-primary text-white px-3 py-2 w-72 text-center fw-medium fs-base rounded-pill" data-tooltip-id="my-tooltip-click" data-tooltip-variant="light"> {allItems.length} Items Added</a>
                        <Tooltip
                            style={{ pointerEvents: 'auto' }}
                            id="my-tooltip-click"
                            className="bg-primary"
                            render={(content) => (
                                content = <div className="g-col-12 g-col-lg-12">
                                    <div className="intro-y w-72">
                                        <div className="box p-1">
                                            <ul className="pos__tabs nav nav-pills rounded-2" role="tablist">
                                                <li id="ticket-tab" className="nav-item flex-1" role="presentation">
                                                    <button className="nav-link w-full btn-pprimary fs-lg pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#ticket" type="button" role="tab" aria-controls="ticket-tab" aria-selected="true">Items</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="tab-content w-72 py-2">
                                        <div className="tab-pane fade show active" id="ticket" role="tabpanel" aria-labelledby="ticket-tab">
                                            <div className="box p-2">
                                                {
                                                    allItems && allItems.length > 0 ?
                                                        allItems.map((item, index) => {
                                                            return (
                                                                <span className="ticket-item box mb-2 d-flex align-items-center p-3 cursor-pointer bg-white dark-bg-dark-3 bg-gray-200-hover dark-bg-dark-1-hover rounded-2">
                                                                    <button onClick={(e) => deleteItem(e, item, index)} type="button" className="bg-transparent"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 text-theme-6 me-2 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> </button>
                                                                    <div className="ticket-item__item-name text-dark truncate me-1 fs-base">{item?.product_name}&nbsp;</div>
                                                                    <div className="w-24 me-1 ms-auto fw-medium text-dark fs-base">
                                                                        <div class="input-group w-24 ">
                                                                            <div class="input-group-text cursor-pointer fw-medium" onClick={() => minusQuantity(index)}>-</div>
                                                                            <input type="text" class="form-control text-center p-1" value={item?.quantity} placeholder="Quantity" />
                                                                            <div onClick={() => addQuantity(index)} class="input-group-text cursor-pointer fw-medium">+</div>
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            )
                                                        })
                                                        :
                                                        <div className="ticket-item__item-name truncate me-1 text-dark py-2 px-3">No Items Added</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            events={['click']}
                        />
                    </div>

                    : ''
            }

        </React.Fragment >
    );
};

export default Step3;